document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname;

  if (currentPath !== "/") {
    return;
  }

  // Infinite Scroll
  const infinteScrollContainer = document.getElementById(
    "infinte-scroll-container"
  );

  const items = Array.from(infinteScrollContainer.children);

  items.forEach((item) => {
    const clone = item.cloneNode(true);
    infinteScrollContainer.appendChild(clone);
  });

  // Counter Animation
  const counters = document.querySelectorAll(
    ".section__core-values .bottom span"
  );
  let animated = false;

  const animateCounters = () => {
    counters.forEach((counter) => {
      const targetAttr = counter.getAttribute("data-target");
      if (!targetAttr) return;

      const isPercent =
        counter.hasAttribute("data-percent") || targetAttr.includes("%");
      const target = parseFloat(targetAttr.replace("%", ""));
      let current = 0;
      const duration = 2000;
      const steps = 60;
      const increment = target / steps;
      const intervalTime = duration / steps;

      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          counter.textContent = isPercent ? `${target}%` : `${target}`;
          clearInterval(timer);
        } else {
          counter.textContent = isPercent
            ? `${Math.floor(current)}%`
            : `${Math.floor(current)}`;
        }
      }, intervalTime);
    });
  };

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  };

  if (window.location.pathname === "/") {
    const onScroll = () => {
      if (
        !animated &&
        isElementInViewport(
          document.querySelector(".section__core-values .bottom")
        )
      ) {
        animateCounters();
        animated = true;
        window.removeEventListener("scroll", onScroll);
      }
    };

    window.addEventListener("scroll", onScroll);
    onScroll();
  }

  // Reviews section
  if (window.location.pathname === "/") {
    const hiddenHTML = document.getElementById(
      "homepage-admin-data"
    )?.innerHTML;

    const parser = new DOMParser();
    const doc = parser.parseFromString(hiddenHTML, "text/html");
    const reviewElements = doc.querySelectorAll("p");

    const reviews = [];

    reviewElements.forEach((p) => {
      const parts = p.innerHTML.split("<br>");
      if (parts.length < 4) return;

      const reviewText = parts[0].trim().replace(/“|”/g, '"');
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = parts[1];
      const imgEl = tempDiv.querySelector("img");

      const image = imgEl?.getAttribute("src") || "";
      const name = parts[2].replace(/<\/?strong>/g, "").trim();
      const position = parts[3].replace(/<\/?em>/g, "").trim();

      if (reviewText && image && name && position) {
        reviews.push({
          text: reviewText,
          image: new URL(image).pathname,
          name,
          position,
        });
      }
    });

    if (reviews.length) {
      let currentIndex = 0;

      const updateReview = (index, directionClass) => {
        const review = reviews[index];
        if (!review) return;

        const wrapper = document.getElementById("review-text-wrapper");
        const reviewerInfo = document.getElementById("reviewer-info");

        const newSpan = document.createElement("span");
        newSpan.textContent = review.text;
        newSpan.classList.add(directionClass);
        wrapper.appendChild(newSpan);

        void newSpan.offsetWidth;
        newSpan.classList.add("active");

        const oldSpan = wrapper.querySelector("span:not(:last-child)");
        if (oldSpan) oldSpan.remove();

        reviewerInfo.querySelector("img").src = review.image;
        reviewerInfo.querySelector("img").alt = review.name;
        reviewerInfo.querySelector("#reviewer-name").textContent = review.name;
        reviewerInfo.querySelector("#reviewer-position").textContent =
          review.position;

        setTimeout(() => {
          newSpan.classList.remove("active__left", "active__right");
        }, 200);
      };

      const changeReview = (direction) => {
        const dirClass = direction === 1 ? "active__right" : "active__left";
        currentIndex =
          (currentIndex + direction + reviews.length) % reviews.length;
        updateReview(currentIndex, dirClass);
      };

      document
        .querySelector(".carousel__arrow--left-web")
        ?.addEventListener("click", () => changeReview(-1));
      document
        .querySelector(".carousel__arrow--left-mobile")
        ?.addEventListener("click", () => changeReview(-1));
      document
        .querySelector(".carousel__arrow--right")
        ?.addEventListener("click", () => changeReview(1));

      updateReview(currentIndex, "active__right");
    }
  }
});
